/**
 * Finds the deepest matching key.
 *
 * @returns {object} The deepest matching key index and matching object.
 */
const findDeepestMatch = (prev, curr, index) => {
	if (prev.done) return prev;

	const obj = prev.obj;
	if (obj[curr]) return { obj: obj[curr] };
	return { done: true, index, obj };
};

/**
 * Creates an object from an array of keys.
 *
 * @returns {object} Object with nested objects and value.
 */
const reduceNestedKeys = (prev, curr) => ({ [curr]: prev });

const reduceFormData = (prev, [key, untrimmedValue]) => {
	const value = untrimmedValue.trim();
	if (key.includes('.')) {
		const obj = { ...prev };
		const keyArray = key.split('.');
		const { index, obj: nestedObj } = keyArray.reduce(findDeepestMatch, { obj });
		nestedObj[keyArray[index]] = keyArray.slice(index + 1).reduceRight(reduceNestedKeys, value);
		return obj;
	} else {
		return { ...prev, [key]: value };
	}
};

export default (form) => [...new FormData(form).entries()].reduce(reduceFormData, {});



// WEBPACK FOOTER //
// ./src/utils/formToJson.js